import { Vue, Component, Ref } from 'vue-property-decorator'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'
import ArrowSvg from '~/assets/svg/main-slider-arrow.svg?inline'
import { SliderSlick, SliderSlickOptions } from '~/types/Slider'
import { SfSection } from '~/types/api/SfSection'
import Preloader from '~/components/element/Preloader'
import EmptyPlaceholder from '~/assets/svg/No_image.svg'
import mainPage from '~/store/mainPage'

@Component
export default class MainCatalogSectionsSlider extends Vue {
  @Ref()
  readonly sectionSlider!: SliderSlick

  currentSlide: number = 0
  visible: Boolean = false
  mainPageStore: mainPage

  constructor () {
    super()
    this.mainPageStore = s(this.$store).mainPage
  }

  beforeCreate () {
    s(this.$store).general.initSections()
  }

  mounted () {
    s(this.$store).mainPage.getSectionsSlider()
  }

  get optionsSlider (): SliderSlickOptions {
    return {
      slidesToShow: (this as any).$mq === 'sm' ? 2 : (this as any).$mq === 'xl' ? 4 : 3,
      infinite: true,
      arrows: false,
      dots: false
    }
  }

  get items (): SfSection[] {
    return this.mainPageStore.sections
  }

  link (id: string) {
    const helper = new SectionHelper(this.mainPageStore.sections, this.$store)
    return helper.getSectionPathById(id)
  }

  openLink (id: string) {
    const link = this.link(id)
    if (link) {
      this.$router.push(link)
    }
  }

  get count (): number {
    return this.items.length
  }

  change (index: number) {
    this.currentSlide = index
  }

  next () {
    this.sectionSlider.next()
  }

  prev () {
    this.sectionSlider.prev()
  }

  isIconSlider (item: SfSection): boolean {
    return item.sliderIcon !== undefined
  }

  renderItem (item: SfSection) {
    return (
      <div class="main-catalog-sections-slider__item-wrapper" onClick={() => this.openLink(item.id)} key={item.id}>
        <div class="main-catalog-sections-slider__item">
          <div class="main-catalog-sections-slider__item-image" v-intersection-observe>
              {this.isIconSlider(item) && (
                <img data-src={item.sliderIcon} placeholder={EmptyPlaceholder} alt={item.name} />
              )}
          </div>
          <div class="main-catalog-sections-slider__item-text">
            {item.name}
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="main-catalog-sections-slider">
        <div>
          <div class="main-catalog-sections-slider__track">
            <transition name="fade">
              {(!this.visible || this.items.length < 1) &&
              <div key="main-catalog-sections-slider__preloader"
                class="main-catalog-sections-slider__preloader">
                <Preloader/>
              </div>}
            </transition>

            {this.items.length > 0 && (
              <vue-slick-carousel ref="sectionSlider"
                {...{ style: { opacity: this.visible ? 1 : 0 } }}
                onAfterChange={this.change}
                onInit={() => { this.visible = true }}
                slidesToShow={this.optionsSlider.slidesToShow}
                infinite={this.optionsSlider.infinite}
                navButtons={this.optionsSlider.arrows}
                dots={this.optionsSlider.dots}
                arrows={this.optionsSlider.arrows}
                draggable={(this as any).$mq === 'sm'}
              >
                {this.items.map(e => this.renderItem(e))}
              </vue-slick-carousel>)}
          </div>

          {this.items.length > 0 && (
            <div class="main-catalog-sections-slider__nav">
              <div {...{
                on: {
                  click: this.prev
                },
                class: {
                  'main-catalog-sections-slider__nav-prev': true,
                  'main-catalog-sections-slider__nav-available': this.optionsSlider.slidesToShow < this.count && this.visible
                }
              }}>
                <ArrowSvg/>
              </div>
              <div {...{
                on: {
                  click: this.next
                },
                class: {
                  'main-catalog-sections-slider__nav-next': true,
                  'main-catalog-sections-slider__nav-available': this.optionsSlider.slidesToShow < this.count && this.visible
                }
              }}>
                <ArrowSvg/>
              </div>
            </div>)}
        </div>
      </div>)
  }
}
